module.exports = __webpack_public_path__ + "img/default_2x.0d049ad2.svg";